import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import 'firebase/firestore';

@Injectable()
export class FirestoreProvider {

  db = firebase.firestore();

  constructor() {}

  /**
   * Gets snapshot from a collection
   * @param path collection's path
   */
  public getCollection(path: string) {
    let collectionsRef = this.db.collection(path);
    return collectionsRef.get();
  }

  /**
   * Gets the reference from a collection
   * @param path collection's path
   */
  public watchCollection(path: string) {
    let collectionsRef = this.db.collection(path);
    return collectionsRef;
  }

  /**
   * Adds a document do a collection
   * @param path collection's path
   * @param doc document to create 
   */
  public addToCollection(path: string, doc: any) {
    let collectionsRef = this.db.collection(path);
    return collectionsRef.add(doc);
  }

  /**
   * Gets a snapshot from a document
   * @param path document's path
   */
  public getDocument(path: string) {
    let documentRef = this.db.doc(path);
    return documentRef.get();
  }

  /**
   * Gets the reference from a document
   * @param path document's path
   */
  public watchDocument(path: string) {
    let documentRef = this.db.doc(path);
    return documentRef;
  }

  /**
   * Creates a document if it does not exists or update existing document
   * @param path document's path 
   * @param doc document to create or update 
   */
  public addDocument(path: string, doc: any) {
    let documentRef = this.db.doc(path);
    return documentRef.set(doc);
  }

  /**
   * Creates a batch, saves the documents array and commits it
   * @param path collection's path 
   * @param docsArray documents to add 
   */
  public addDocumentsInBatch(path: string, docsArray: Array<Object>) {
    const collection = this.db.collection(path);
    const batch: any = this.db.batch();    
    docsArray.forEach(val => {
      batch.set(collection.doc(), val);
    });
    return batch.commit();
  }

  /**
   * Update a document with new fields
   * @param path document's path 
   * @param doc doc with new fields to update
   */
  public updateDocument(path: string, doc: any) {
    let documentRef = this.db.doc(path);
    return documentRef.update(doc);
  }

  /**
   * Deletes document
   * @param path document's path 
   */
  public removeDocument(path: string) {
    let documentRef = this.db.doc(path);
    return documentRef.delete();
  }

  /**
   * Close all subscriptions
   * @param subscriptions object with subscriptions to close
   */
  public unsubscribe(subscriptions: any) {
    for (const sub in subscriptions) {
      if (subscriptions.hasOwnProperty(sub)) {
        if (typeof subscriptions[sub]['unsubscribe'] == 'function') return subscriptions[sub].unsubscribe();
        else if (typeof subscriptions[sub] == 'function') return subscriptions[sub]();
        else return;
      }
    }
  }

}
